import { isClient } from "@tamagui/core";
const constants = {};
const SHEET_NAME = "Sheet";
const SHEET_HANDLE_NAME = "SheetHandle";
const SHEET_OVERLAY_NAME = "SheetOverlay";
const HIDDEN_SIZE = 1e4;
const SHEET_HIDDEN_STYLESHEET = isClient ? document.createElement("style") : null;
if (SHEET_HIDDEN_STYLESHEET) {
  document.head.appendChild(SHEET_HIDDEN_STYLESHEET);
}
export {
  HIDDEN_SIZE,
  SHEET_HANDLE_NAME,
  SHEET_HIDDEN_STYLESHEET,
  SHEET_NAME,
  SHEET_OVERLAY_NAME,
  constants
};
//# sourceMappingURL=constants.js.map
